var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('dialog-loading'):_vm._e(),(!_vm.loading && _vm.task)?_c('dialog-create-task',{attrs:{"task":_vm.task,"is_edit":"","is_new":false},on:{"cancel":_vm.handleCancel,"done":_vm.handleDone}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }